//Generated File 
export const Approve = `Approve`;
export const CanViewMoreMenu = `CanViewMoreMenu`;
export const CanViewTransaction = `CanViewTransaction`;
export const ChangeCapability = `ChangeCapability`;
export const Commit = `Commit`;
export const CreateDraft = `CreateDraft`;
export const Delete = `Delete`;
export const DeleteAfterApproval = `DeleteAfterApproval`;
export const DeleteAfterPrint = `DeleteAfterPrint`;
export const DeleteDraft = `DeleteDraft`;
export const Duplicate = `Duplicate`;
export const EditAfterApproval = `EditAfterApproval`;
export const EditAfterCommit = `EditAfterCommit`;
export const EditAfterPrint = `EditAfterPrint`;
export const EditUnderApproval = `EditUnderApproval`;
export const Export = `Export`;
export const Import = `Import`;
export const ListView = `ListView`;
export const Other = `Other`;
export const PrintDraft = `PrintDraft`;
export const PrintMoreThanOnce = `PrintMoreThanOnce`;
export const PrintOnce = `PrintOnce`;
export const RecordView = `RecordView`;
export const Revise = `Revise`;
export const SaveDraft = `SaveDraft`;
export const SearchView = `SearchView`;
export const Unrevise = `Unrevise`;
export const ViewWithFromDoc = `ViewWithFromDoc`;
